import { render, staticRenderFns } from "./VolumeIntensityScatterChart.vue?vue&type=template&id=b973e882"
import script from "./VolumeIntensityScatterChart.vue?vue&type=script&lang=js"
export * from "./VolumeIntensityScatterChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports